import i18n from '../../middleware/i18n'

export default i18n
